export const SHOP_ENGBERS_KEY = 'engbers';
export const SHOP_EMILIO_ADANI_KEY = 'emilio-adani';
export const SHOP_GERMANY_KEY = 'engbers-germany';
export const SHOP_XXL_KEY = 'engbers-xxl';

export type Shop = typeof SHOP_ENGBERS_KEY | typeof SHOP_EMILIO_ADANI_KEY | typeof SHOP_GERMANY_KEY | typeof SHOP_XXL_KEY;

export const mapShop = (shop?: string): string => {
  return (
    {
      [SHOP_XXL_KEY]: 'XXL',
      [SHOP_GERMANY_KEY]: 'ENGBERS GERMANY',
      [SHOP_EMILIO_ADANI_KEY]: 'emilio adani',
    }[shop ?? ''] || 'engbers'
  );
};

export const isEngbersGermany = (currentShop: string) => currentShop === SHOP_GERMANY_KEY;
